export enum allRoutes {
  default = "/",
  auth = "/auth",
  adminTrainerApp = "/admin",
  adminDashboard = "/dashboard",
  adminManagement = "/verwaltung",
}
